import React, { useState, useContext } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SidebarLogo from "./SidebarLogo";
import {
  privateRoles,
  tcRoles,
  adminRoles,
  adminMenuRoles,
  stateAdminRole,
} from "../Data/UserRolesData";

//Context import
import AuthContext from "../shared/Context";

import "./LeftSideBar.css";
import PurchaseRequestMenu from "./PurchaseRequestMenu";
import StateInventoryMenu from "./StateInventoryMenu";
import TCInventoryMenu from "./TCInventoryMenu";
import SupplierMenu from "./SupplierMenu";

const LeftSideBar = () => {
  const { showFooterLogo, loggedInUserDetails, expandedMenu, setExpandedMenu } =
    useContext(AuthContext);
  const location = useLocation();

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const isActiveParent = (paths) => {
    return paths.some((path) => location.pathname.startsWith(path));
  };

  return (
    <div className={`leftside-menu ${!expandedMenu ? "minimized" : ""}`}>
      {/* ========== Left Sidebar Start ========== */}
      <SidebarLogo />
      <div className="h-100" id="leftside-menu-container" data-simplebar>
        {/*- Sidemenu */}
        <ul className="side-nav">
          <li className="side-nav-title side-nav-item">Navigation</li>
          <li className="side-nav-item">
            <div
              onClick={() =>
                setExpandedMenu({
                  ...expandedMenu,
                  dashboard: !expandedMenu.dashboard,
                })
              }
              className={`side-nav-link ${
                isActiveParent(["/dashboard-tc", "/dashboard-state"])
                  ? "active"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <i className="uil-home-alt" />
              <span className="badge bg-success float-end">New</span>
              <span> Dashboards </span>
            </div>
            <div
              className={`${
                expandedMenu.dashboard ? "collapse show" : "collapse"
              }`}
              id="sidebarDashboards"
            >
              <ul className="side-nav-second-level">
                {/* Defined in UserRolesData */}
                {tcRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/dashboard-tc"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      Treatment Center
                    </NavLink>
                  </li>
                )}
                {/* Defined in UserRolesData */}
                {privateRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/dashboard-tc"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      Treatment Center
                    </NavLink>
                  </li>
                )}
                {/* Defined in UserRolesData */}
                {adminMenuRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/dashboard-state"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      State Analytics
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
          <li className="side-nav-title side-nav-item">Quick Menu</li>
          <li className="side-nav-item " style={{ backgroundColor: "#202020" }}>
            <NavLink
              to="/help-dash"
              className={({ isActive }) =>
                `side-nav-link ${isActive ? "active" : ""}`
              }
            >
              <i className="mdi mdi-information" style={{ color: "yellow" }} />
              <span className="text-darkgray mr-4"> Application Help</span>
              &nbsp;&nbsp;
              <i
                className="mdi mdi-help-circle"
                style={{ color: "lightblue" }}
              />
            </NavLink>{" "}
          </li>
          <li className="side-nav-item">
            <NavLink
              to="/upcoming/appointments"
              className={({ isActive }) =>
                `side-nav-link ${isActive ? "active" : ""}`
              }
            >
              <i className="mdi mdi-calendar-clock" />
              <span>Upcoming Appointments</span>
            </NavLink>
          </li>
          <li className="side-nav-item">
            <NavLink
              to="/pre/register/list"
              className={({ isActive }) =>
                `side-nav-link ${isActive ? "active" : ""}`
              }
            >
              <i className="mdi mdi-clipboard-account" />
              <span> Pre Registrations </span>
            </NavLink>
          </li>
          <li className="side-nav-item">
            <div
              onClick={() =>
                setExpandedMenu({
                  ...expandedMenu,
                  patients: !expandedMenu.patients,
                })
              }
              className={`side-nav-link ${
                isActiveParent([
                  "/patients",
                  "/add-diagnosis",
                  "/global/search",
                  "/import-patients",
                ])
                  ? "active"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <i className="uil-user" />
              <span> Patients </span>
              {!expandedMenu.patients && <span className="menu-arrow" />}
              {expandedMenu.patients && (
                <span
                  className="menu-arrow"
                  style={{ transform: "rotate(90deg)" }}
                />
              )}
            </div>
            <div
              className={`${
                expandedMenu.patients ? "collapse show" : "collapse"
              }`}
            >
              <ul className="side-nav-second-level">
                <li>
                  <NavLink
                    to="/patients"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <i className="uil-document-layout-left" />
                    <span> List Patients </span>
                  </NavLink>
                </li>
                {tcRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/add-diagnosis"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <i className="uil-user-plus" />
                      <span> Add Patients </span>
                    </NavLink>
                  </li>
                )}
                {privateRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/add-diagnosis"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <i className="uil-user-plus" />
                      <span> Add Patients </span>
                    </NavLink>
                  </li>
                )}
                {tcRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/global/search"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <i className="uil-search" />
                      <span> Search Patients </span>
                    </NavLink>
                  </li>
                )}
                {privateRoles.includes(loggedInUserDetails?.role) && (
                  <li>
                    <NavLink
                      to="/global/search"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <i className="uil-search" />
                      <span> Search Patients </span>
                    </NavLink>
                  </li>
                )}
                {loggedInUserDetails?.patient_import_status && (
                  <li>
                    <NavLink
                      to="/import-patients"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <i className="mdi mdi-file-import" />
                      <span> Import Patients </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
          <li className="side-nav-item">
            <div
              onClick={() =>
                setExpandedMenu({
                  ...expandedMenu,
                  reports: !expandedMenu.reports,
                })
              }
              className={`side-nav-link ${
                isActiveParent([
                  "/reports/generic",
                  "/reports/severitywise",
                  "/reports/jointswise",
                  "/reports/bleedwise",
                ])
                  ? "active"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <i className="mdi mdi-google-analytics" />
              <span> Reports </span>
              {!expandedMenu.reports && <span className="menu-arrow" />}
              {expandedMenu.reports && (
                <span
                  className="menu-arrow"
                  style={{ transform: "rotate(90deg)" }}
                />
              )}
            </div>
            <div
              className={`${
                expandedMenu.reports ? "collapse show" : "collapse"
              }`}
              id="sidebarEmail"
            >
              <ul className="side-nav-second-level">
                <li>
                  <NavLink
                    to="/reports/generic"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span> Generic Reports </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/reports/severitywise"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span> Severity-wise </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/reports/jointswise"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span> Joints-wise </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/reports/bleedwise"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span> Bleed-wise </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li className="side-nav-title side-nav-item">Drug Inventory</li>
          {/* Suppliers Menu for TCs*/}
          {tcRoles.includes(loggedInUserDetails?.role) && (
            <SupplierMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
            />
          )}
          {/* Suppliers Menu for Admins*/}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <SupplierMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
            />
          )}
          <li className="side-nav-item">
            <NavLink
              to="/products"
              className={({ isActive }) =>
                `side-nav-link ${isActive ? "active" : ""}`
              }
            >
              <i className="uil-capsule" />
              <span> Product Master </span>
            </NavLink>
          </li>
          {/* Purchase Request Menu for TCs */}
          {tcRoles.includes(loggedInUserDetails?.role) && (
            <PurchaseRequestMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
            />
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <PurchaseRequestMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
              tcRoles={tcRoles && tcRoles}
              loggedInUserDetails={loggedInUserDetails && loggedInUserDetails}
            />
          )}
          {/* StateInventory for  States and Admin only */}
          {adminRoles.includes(loggedInUserDetails?.role) && (
            <StateInventoryMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
            />
          )}
          {stateAdminRole.includes(loggedInUserDetails?.role) && (
            <StateInventoryMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
            />
          )}
          {/* TC Inventory  for TC's Only */}
          {tcRoles.includes(loggedInUserDetails?.role) && (
            <TCInventoryMenu
              setExpandedMenu={setExpandedMenu}
              expandedMenu={expandedMenu}
              nodalStatus={loggedInUserDetails?.nodal_status}
            />
          )}

          <li className="side-nav-item">
            <NavLink
              to="/recommndeddrugs"
              className={({ isActive }) =>
                `side-nav-link ${isActive ? "active" : ""}`
              }
            >
              <i className="mdi mdi-pharmacy" />
              <span className="badge bg-danger text-light float-end">New</span>
              <span> Recommended Drugs </span>
            </NavLink>
          </li>

          <li className="side-nav-title side-nav-item">KnowledgeBase</li>
          <li className="side-nav-item">
            <NavLink
              to="/listkb"
              className={({ isActive }) =>
                `side-nav-link ${isActive ? "active" : ""}`
              }
            >
              <i className="mdi mdi-newspaper" />
              <span className="badge bg-primary text-light float-end">New</span>
              <span> List Papers </span>
            </NavLink>
          </li>
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-title side-nav-item">Administrator</li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/users"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="uil-user" />
                <span className="badge bg-secondary text-light float-end">
                  New
                </span>
                <span> Users </span>
              </NavLink>
            </li>
          )}
          {!adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/doctors"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="uil-user" />
                <span className="badge bg-secondary text-light float-end">
                  New
                </span>
                <span> Doctors </span>
              </NavLink>
            </li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/roles"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="mdi mdi-shield-account" />
                <span> Roles </span>
              </NavLink>
            </li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/tcenters"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="mdi mdi-city-variant-outline" />
                <span> Treatment Centers </span>
              </NavLink>
            </li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/diagnosis"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="mdi mdi-medical-bag" />
                <span> Diagnosis Menu </span>
              </NavLink>
            </li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/entrylogs"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="mdi mdi-pencil-circle" />
                <span> Entry Logs </span>
              </NavLink>
            </li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/errorlogs"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="mdi mdi-bug-outline" />
                <span> Error Logs </span>
              </NavLink>
            </li>
          )}
          {adminMenuRoles.includes(loggedInUserDetails?.role) && (
            <li className="side-nav-item">
              <NavLink
                to="/activitylogs"
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="mdi mdi-clock-alert" />
                <span> Activity Logs </span>
              </NavLink>
            </li>
          )}
          {/* disable before final rollout */}
          {/* <li className="side-nav-item">
            <NavLink to="/errorlogs" className="side-nav-link">
              <i className="mdi mdi-bug-outline" />
              <span> Error Logs </span>
            </NavLink>
          </li> */}
          {/* --end-- */}
        </ul>
        {/* End Sidebar */}
        <span className="collapse sidebar-collapse display-logo">
          <div
            className="help-box text-white d-flex justify-content-center"
            style={{ marginTop: "50px", backgroundColor: "white" }}
          >
            <img
              src="assets/images/brands/Roche_Logo_500px_Blue_RGB.png"
              alt
              height={30}
            />
          </div>
        </span>
        <div className="clearfix" />
      </div>
      {/* Sidebar -left */}
    </div>
  );
};

export default LeftSideBar;
